import React, { useContext, useState } from "react";

import Header from "../../components/Header";
import { Context as PermissoesContext } from "../../Context/PermissoesContext";

import Abas from "./Componentes/Abas";
import { IntervaloDataContextProvider } from "./Context/IntevervaloDataContext";
import { NotasFiscaisContextProvider } from "./Context/NotasFiscaisContext";
import FaturamentoTabela from "./FaturamentoTabela";
import NaoLoteados from "./NaoLoteados";
import NotasFiscais from "./NotasFiscais";
import Recebimento from "./Recebimento";
import { ModalRecebimentoContextProvider } from "./Recebimento/Context/ModalRecebimentoContext";
import { RecebimentoContextProvider } from "./Recebimento/Context/RecebimentoContext";

import "./styles.css";

const TABS = [
  {
    id: 3,
    label: "Faturamento",
    permission: "FAT003",
    component: <FaturamentoTabela />,
  },
  {
    id: 4,
    label: "Recebimento",
    permission: "FAT004",
    component: <Recebimento />,
  },
  {
    id: 5,
    label: "Nao Loteado",
    permission: "FAT005",
    component: <NaoLoteados />,
  },
  {
    id: 6,
    label: "Notas Fiscais",
    permission: "FAT013",
    component: <NotasFiscais />,
  },
];

export default function Faturamento() {
  const { checarPermissaoComAcao } = useContext(PermissoesContext);
  const [tab, setTab] = useState(3);

  const handleTabChange = (tabId) => {
    const selectedTab = TABS.find((item) => item.id === tabId);

    if (!selectedTab) {
      return;
    }

    checarPermissaoComAcao(selectedTab.permission, () => setTab(tabId));
  };

  const activeTab = TABS.find((item) => item.id === tab);

  return (
    <>
      <Header titulo="Faturamento" />
      <IntervaloDataContextProvider>
        <ModalRecebimentoContextProvider>
          <RecebimentoContextProvider>
            <NotasFiscaisContextProvider>
              <div className="container-central-faturamento">
                <main className="container-abas-faturamento">
                  <Abas
                    tabs={TABS}
                    value={tab}
                    handleChange={handleTabChange}
                  />
                </main>
                {activeTab?.component}
              </div>
            </NotasFiscaisContextProvider>
          </RecebimentoContextProvider>
        </ModalRecebimentoContextProvider>
      </IntervaloDataContextProvider>
    </>
  );
}
